import script from "./TypeSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./TypeSelection.vue?vue&type=script&setup=true&lang=js"

import "./TypeSelection.vue?vue&type=style&index=0&id=0db95414&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0db95414"]])

export default __exports__